<ion-content>
  <div style="padding: 10px;" [innerHTML]="content | noSanitize"></div>
</ion-content>
<ion-footer>
  <ion-row>
    <ion-col>
      <ion-button shape="round" expand="block" (click)="clickGreet(false)">不同意</ion-button>
    </ion-col>
    <ion-col>
      <ion-button shape="round" expand="block" (click)="clickGreet(true)">同意</ion-button>
    </ion-col>
  </ion-row>
</ion-footer>